import React from 'react';
import './Message.less';
import {IconBadge, IconBadgeColors} from "elements/icon-badge/IconBadge";
import {ErrorMessageTitle} from "elements/error-message-title/ErrorMessageTitle";
import {ErrorMessageDescription} from "elements/error-message-description/ErrorMessageDescription";
import {applyTags} from "helpers/format.helper";

export const Message = ({icon, title, description, description2}) => {
	return <div className="message">
		<div className="message__container">
			<div className="message__icon">
				<IconBadge icon={icon} color={IconBadgeColors.dark} isBig/>
			</div>
			{
				title && (<div className="message__title">
					<ErrorMessageTitle text={title}/>
				</div>)
			}
		</div>
		<div className="message__description">
			<ErrorMessageDescription text={applyTags(description)}/>
			{description2 && (
					<>
						<br/>
						<ErrorMessageDescription text={applyTags(description2)} />
					</>
				)}
		</div>
	</div>
}
